module.exports = "<div class=\"form-group secondary-gauge\">\n  <div class=\"col-sm-9\">\n    <select class=\"form-control\" disabled></select>\n    <input\n      class=\"input-sm form-control gauge-custom-label-input <%- enableCustomLabels ? '' : 'hidden' %>\"\n      placeholder=\"Custom label\"\n    />\n  </div>\n  <div class=\"col-md-2\">\n    <i class=\"fa fa-trash clickable gauge-delete\"></i>\n  </div>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./srv/public/js/templates/modals/dashboard/modify_widgets/lobbyview/gauge.html
// module id = 920
// module chunks = 7